import { t } from "i18next";
import { useState, useContext, useEffect  } from "react"; 
import { useTranslation } from "react-i18next";
import axios from "axios";
import Select from 'react-select'
const { NavLink, useLocation } = require("react-router-dom")
const { ConfigContext } = require("../../Context/ConfigContext")

const PartInfo = () => {
    const {apiURL, token, lang, gdcURL} = useContext(ConfigContext);
    const { t } = useTranslation();
    const dir = localStorage.getItem('dir');

    const [partNumber, setPartNumber] = useState('');
    const [partInfo, setPartInfo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [suppliers, setSuppliers] = useState([]);
    const [responseData, setResponseData] = useState([]);
    const locale = localStorage.getItem("lang") ?? "en";
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const customStyles = {
        control: base => ({
          ...base,
          height: 46,
          minHeight: 35
        })
      };
    useEffect(() => {
        window.scrollTo(0, 0)
        var config = {
            method: 'get',
            url: `${gdcURL}/Suppliers/GetSuppliers`,
            headers: { }
        };

        axios(config)
        .then(function (response) {
            setResponseData(response.data.data);
            const formattedSuppliers = response.data.data.map(supplier => ({
                label: supplier.SUP_BRAND,
                value: supplier.SUP_ID
            }));
            setSuppliers(formattedSuppliers);
            
            
        })
        .catch(function (error) {
        });

    }, [])
    const getPartInfo = async () => {
        if (!partNumber) {
            setError('Please enter a part number');
            return;
        }
        if (!selectedSupplier) {
            setError('Please select a supplier');
            return;
        }
        
        
        setLoading(true);
        setError('');
        try {
            const cleanPartNumber = partNumber.replace(/[^a-zA-Z0-9]/g, '');
            const response = await axios.get(`https://dcapi.carz7.com/Parts/GetPartInformationByNumber?part_number=${cleanPartNumber}&sup_id=${selectedSupplier}`);
            setPartInfo(response.data);
        } catch (err) {
            setError('Failed to fetch part information');
            console.error('Error:', err);
        } finally {
            setLoading(false);
        }
    };

    const location = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location])

    
    return (
        <div dir={dir} style={{textAlign: dir === 'ltr'?'left': 'right'}}>
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-md-12">
                        <div className="card shadow-sm">
                            <div className="card-body p-4">
                                <h4 className="card-title mb-4 text-primary">
                                    <i className="fas fa-search me-2"></i>
                                    Part Information Lookup
                                </h4>
                                
                                <div className="search-box mb-4">
                                    <div className="input-group">
                                    <div style={{width: '200px', marginRight: '10px'}}> 
                                    <Select
                                        // value={countries.find(supplier => supplier.SUP_ID === counstryId) || null}
                                        options={suppliers}
                                        styles={customStyles}   
                                        placeholder="Select Supplier"
                                        onChange={(item) => {
                                        setSelectedSupplier(item.value);
                                            console.log('supplier',item.value);

                                        }}
                                    />
                                    </div>
                                        <input 
                                            type="text" 
                                            className="form-control form-control-lg"
                                            placeholder="Enter part number (e.g. 0986452041)"
                                            value={partNumber}
                                            onChange={(e) => setPartNumber(e.target.value)}
                                        />
                                        <button 
                                            className="btn btn-primary" style={{padding: '10px 20px'}}
                                            onClick={getPartInfo}
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Searching...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-search me-2"></i>
                                                    Get Info
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>

                                {error && (
                                    <div className="alert alert-danger d-flex align-items-center" role="alert">
                                        <i className="fas fa-exclamation-circle me-2"></i>
                                        {error}
                                    </div>
                                )}

                                {partInfo && (
                                    <div className="part-info mt-4">
                                        <h5 className="text-primary mb-3">
                                            <i className="fas fa-info-circle me-2 mr-3"></i> 
                                            Part Information
                                        </h5>
                                        <div className="table-responsive">
                                            {
                                                partInfo.info && partInfo.info.length > 0 && 
                                                    <div className="part-info-item mb-3">
                                                        <h3 >{partInfo.info[0].ART_PRODUCT_NAME} - {partInfo.info[0].ART_SUP_BRAND}</h3>
                                                        <p>{partInfo.info[0].ARTICLE_CRITERIA}</p>
                                                    </div>
                                            }
                                            <div className="row mb-3">
                                            {
                                                partInfo && partInfo.pictures.map((item, index) => {
                                                    return item.ART_MEDIA_TYPE !== 'URL' && <div className="col mb-3" key={index} >
                                                        
                                                        <img class="image-gallery-image"  src={`https://dcapi.carz7.com/images/${item.ART_MEDIA_SOURCE}`} style={{height: '150px'}}/>
                                                    </div>
                                                })
                                                    
                                            }
                                            </div>
                                            
                                           
                                            <div className="row">
                                                <div className="col-md-8" style={{borderRight: '1px solid #ccc'}}>
                                                    <h3>This part number Compatibility with following passenger cars                                                    </h3>
                                                    <table className="table table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th>Car</th>
                                                                <th>Year</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {partInfo.cars
                                                                .sort((a, b) => a.TYPEL.localeCompare(b.TYPEL))
                                                                .map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>{item.TYPEL}</td>
                                                                        <td>
                                                                            {new Date(item.PCS_CI_FROM).getFullYear()}
                                                                            {item.PCS_CI_TO ? ` - ${new Date(item.PCS_CI_TO).getFullYear()}`: `- ${new Date().getFullYear()}`}
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <div className="col-md-4">
                                                    <h3>Supported OE Numbers</h3>
                                                    {partInfo && partInfo.info && partInfo.info[0].OEM_NUMBERS && (
                                                        <div className="oe-numbers-list">
                                                            {partInfo.info[0].OEM_NUMBERS.split('\n').map((oe, index) => (
                                                                <div key={index} className="mb-1">
                                                                    <span  style={{ 
                                                                        display: 'inline-block', 
                                                                        whiteSpace: 'normal', 
                                                                        textAlign: 'left',
                                                                        wordBreak: 'break-word',
                                                                        width: '100%',
                                                                    }}>
                                                                        {oe}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-section">
            </div>
        </div>
    )
}

export default PartInfo;